import {
    REQUEST_USERS,
    RECEIVE_USERS,
    UPDATE_USERS,
    ERROR_USERS
} from '../types'
import {fetchUrl} from '../../constants/constants'
import {requestItem, receiveItem, failedItem} from "../actions"
import fetchErrorCtrl from "../../helpers/fetchErrorCtrl"
import shouldFetch from "../../helpers/shouldFetch"
import {reloadEnums} from "../actions"
import axios from 'axios'
import prepareFilters from "../../helpers/prepareFilters";

const sha512 = require('sha512')

function request() {
    return {
        type: REQUEST_USERS
    };
}

export function receive(data) {
    return {
        type: RECEIVE_USERS,
        payload: data
    }
}

function failed(data) {
    return {
        type: ERROR_USERS,
        errors: data
    }
}

function update(data, id, updateType) {
    return {
        type: UPDATE_USERS,
        id,
        payload: data,
        updateType
    }
}

export function getUsers(params = {}, force = false) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().users, !force)) {
            dispatch(request())
            return axios({
                method: 'GET',
                url: fetchUrl + 'users',
                params: prepareFilters(params, getState(), "users")
            }).then(res => {
                dispatch(receive(res.data.data))
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failed(errors))
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function getUser(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('user'))
            return axios({
                method: 'GET',
                url: fetchUrl + 'users/' + id
            }).then(res => {
                dispatch(receiveItem(res.data.data))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function createUser(data) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            if (data.password) {
                data.password = sha512(data.password).toString('hex')
            }
            return axios({
                method: 'POST',
                url: fetchUrl + 'users',
                data
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_created'))
                dispatch(update(res.data.data, false, 'create'))
                dispatch(reloadEnums('users'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function updateUser(data, id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem('user'))
            if (data.password) {
                data.password = sha512(data.password).toString('hex')
            }
            return axios({
                method: 'PUT',
                url: fetchUrl + 'users/' + id,
                data
            }).then(res => {
                dispatch(receiveItem(res.data.data, 'message.item_updated'))
                dispatch(update(res.data.data, id, 'update'))
                dispatch(reloadEnums('users'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}

export function deleteUser(id) {
    return (dispatch, getState) => {
        if (shouldFetch(getState().item)) {
            dispatch(requestItem())
            return axios({
                method: 'DELETE',
                url: fetchUrl + 'users/' + id
            }).then(res => {
                dispatch(receiveItem({}, 'message.item_deleted'))
                dispatch(update(res.data.data, id, 'delete'))
                return true
            }).catch(err => {
                const errors = fetchErrorCtrl(err)
                dispatch(failedItem(errors))
                return errors
            })
        } else {
            return Promise.resolve()
        }
    }
}